@if (failed()) {
  @if (canDelete()) {
    <rt-icon-button
      variant="outline"
      shape="square"
      size="small"
      iconName="delete"
      (click)="action.emit(intents.Delete)"
      [attr.data-cy]="'reports:report:action-' + intents.Delete"
    />
  }
} @else if (anyActionAvailable()) {
  <rt-icon-button
    #dropdownTrigger="rtOverlayOrigin"
    [pressed]="dropdown.open"
    (click)="dropdown.open = true; forceVisibility(true)"
    variant="outline"
    iconName="more-horiz"
    shape="square"
    size="small"
    rt-overlay-origin
    data-cy="reports:report:actions-dropdown-trigger"
  />

  <ng-template
    #dropdown="rtConnectedOverlay"
    [open]="dropdown.open"
    [origin]="dropdownTrigger"
    (backdropClick)="dropdown.open = false"
    (detach)="forceVisibility(false)"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown [width]="DropdownWidth.Small">
      @let upsell = !canEdit();
      <reports-visualization-actions-dropdown-item
        (click)="actionClick($event, intents.Edit, upsell)"
        [label]="'tlr.common.edit' | translate"
        [action]="intents.Edit"
        [class.upsell]="upsell"
        [upsell]="upsell"
        icon="edit"
      />
      @if (fullscreenAvailable()) {
        <reports-visualization-actions-dropdown-item
          (click)="actionClick($event, intents.Fullscreen)"
          [label]="'tlr.common.fullscreen' | translate"
          [action]="intents.Fullscreen"
          [upsell]="false"
          icon="fullscreen"
        />
      }

      @if (canExport()) {
        <reports-visualization-actions-dropdown-item
          (click)="openExportsDropdown($event)"
          [label]="'tlr.exports.export' | translate"
          icon="file-export"
          suffixIcon="chevron-right"
          action="export"
        />
      }

      @if (canDuplicate()) {
        <reports-visualization-actions-dropdown-item
          (click)="actionClick($event, intents.Duplicate, upsell)"
          [label]="'tlr.common.duplicate_button' | translate"
          [action]="intents.Duplicate"
          [class.upsell]="upsell"
          [upsell]="upsell"
          icon="content-copy"
        />
      }
      @if (canMove()) {
        <reports-visualization-actions-dropdown-item
          (click)="actionClick($event, intents.Move, upsell)"
          [label]="'tlr.common.move_to' | translate"
          [action]="intents.Move"
          [class.upsell]="upsell"
          [upsell]="upsell"
          icon="arrow-forward"
        />
      }
      @if (canDelete()) {
        <reports-visualization-actions-dropdown-item
          (click)="actionClick($event, intents.Delete, upsell)"
          [label]="'tlr.common.delete' | translate"
          [action]="intents.Delete"
          [class.upsell]="upsell"
          [upsell]="upsell"
          icon="delete"
        />
      }
    </rt-dropdown>
  </ng-template>
}

<ng-template #exportsTemplate>
  <rt-dropdown-header>
    <rt-icon-button
      (click)="closeExportsDropdown($event)"
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
    <span> {{ 'tlr.exports.export_as' | translate }} </span>
  </rt-dropdown-header>
  <reports-visualization-actions-dropdown-item
    [action]="intents.ExportPng"
    (click)="actionClick($event, intents.ExportPng)"
    label="PNG"
    icon="file-png"
  />
  <reports-visualization-actions-dropdown-item
    [action]="intents.ExportCsv"
    (click)="actionClick($event, intents.ExportCsv)"
    label="CSV"
    icon="file-csv"
  />
  <reports-visualization-actions-dropdown-item
    (click)="actionClick($event, intents.ExportXlsx)"
    label="XLSX (Excel)"
    icon="file-xlsx"
  />
  <reports-visualization-actions-dropdown-item
    (click)="actionClick($event, intents.ExportPdf)"
    label="PDF"
    icon="file-pdf"
  />
</ng-template>
